import React from 'react';
import GraphView from './GraphView';
import GraphViewOfficial from './GraphViewOfficial';

const GraphContainer = props =>
    (<div className="graph-container">
        {props.type === "official" ? <GraphViewOfficial {...props} /> : < GraphView {...props} />}
    </div>);

export default GraphContainer;